module.exports = __webpack_public_path__ + "static/media/airtel-money.86f21e20.png";